import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { useCart } from '../context/CartContext';
import { WOW } from 'wowjs';

/* Manchester Villa Hotel — 4-tier pricing */
const rooms = [
  { id: 'r1', img: '/images/rooms/room-service1-1.jpg', title: 'Standard Room (China)',    price: 30000, flag: '🇨🇳', tier: 'China',  persons: '1–2', bed: 'King Size Bed',  bath: 'En-Suite Bathroom', wifi: true, ac: true, tv: true, sqft: '280 sq ft', type: 'room' },
  { id: 'r2', img: '/images/rooms/room-service1-2.jpg', title: 'Deluxe Room (Canada)',     price: 35000, flag: '🇨🇦', tier: 'Canada', persons: '1–2', bed: 'King Size Bed',  bath: 'En-Suite Bathroom', wifi: true, ac: true, tv: true, sqft: '340 sq ft', type: 'room' },
  { id: 'r3', img: '/images/rooms/room-service1-3.jpg', title: 'Executive Room (UK)',      price: 40000, flag: '🇬🇧', tier: 'UK',     persons: '1–2', bed: 'King Size Bed',  bath: 'En-Suite Bathroom', wifi: true, ac: true, tv: true, sqft: '420 sq ft', type: 'room' },
  { id: 'r4', img: '/images/rooms/room-service1-4.jpg', title: 'Suite (USA)',              price: 70000, flag: '🇺🇸', tier: 'USA',    persons: '1–4', bed: 'King Size Bed',  bath: 'En-Suite + Lounge',  wifi: true, ac: true, tv: true, sqft: '680 sq ft', type: 'room' },
  { id: 'r5', img: '/images/rooms/room-service1-5.jpg', title: 'Classic Room (China)',     price: 30000, flag: '🇨🇳', tier: 'China',  persons: '1–2', bed: 'Double Bed',    bath: 'En-Suite Bathroom', wifi: true, ac: true, tv: true, sqft: '260 sq ft', type: 'room' },
  { id: 'r6', img: '/images/rooms/room-service1-6.jpg', title: 'Classic Plus (Canada)',    price: 35000, flag: '🇨🇦', tier: 'Canada', persons: '1–2', bed: 'Double Bed',    bath: 'En-Suite Bathroom', wifi: true, ac: true, tv: true, sqft: '300 sq ft', type: 'room' },
  { id: 'r7', img: '/images/rooms/room-service1-7.jpg', title: 'Lounge Suite (UK)',        price: 40000, flag: '🇬🇧', tier: 'UK',     persons: '1–3', bed: 'King Size Bed',  bath: 'En-Suite + Sitting Area', wifi: true, ac: true, tv: true, sqft: '500 sq ft', type: 'room' },
];

const tiers = [
  { flag: '🇨🇳', name: 'China',  price: '₦30,000', color: '#e53935' },
  { flag: '🇨🇦', name: 'Canada', price: '₦35,000', color: '#c62828' },
  { flag: '🇬🇧', name: 'UK',     price: '₦40,000', color: '#1565c0' },
  { flag: '🇺🇸', name: 'USA',    price: '₦70,000', color: '#0d47a1' },
];

function RoomCard({ room }) {
  const { addToCart, cartItems } = useCart();
  const [flash, setFlash] = useState(false);
  const inCart = cartItems.some(i => i.id === room.id && i.type === 'room');

  const handleAdd = () => {
    addToCart({ id: room.id, title: room.title, price: room.price, img: room.img, type: 'room', currency: '₦' });
    setFlash(true);
    setTimeout(() => setFlash(false), 1800);
  };

  return (
    <div className="room-card">
      <div className="room-card-img">
        <Link to="/room-details"><img src={room.img} alt={room.title} /></Link>
        <span className="room-price">₦{room.price.toLocaleString()}<small>/night</small></span>
        <span className="room-flag-tag">{room.flag} {room.tier} Rate</span>
      </div>
      <div className="room-card-body">
        <h4 className="room-card-title"><Link to="/room-details">{room.title}</Link></h4>
        <ul className="room-facilities">
          <li><i className="fas fa-user"></i> {room.persons}</li>
          <li><i className="fas fa-bed"></i> {room.bed}</li>
          <li><i className="fas fa-bath"></i> {room.bath}</li>
          {room.wifi && <li><i className="fas fa-wifi"></i> Free WiFi</li>}
          {room.ac && <li><i className="fas fa-snowflake"></i> Air-Con</li>}
          {room.tv && <li><i className="fas fa-tv"></i> Smart TV</li>}
        </ul>
        <div className="room-sqft"><i className="fas fa-ruler-combined me-1"></i>{room.sqft}</div>
        <div className="room-card-actions">
          <Link to="/room-details" className="btn-details">View Details</Link>
          <button className={`btn-book${inCart ? ' in-cart' : ''}${flash ? ' just-added' : ''}`} onClick={handleAdd}>
            {flash ? <><i className="fas fa-check"></i> Added!</> : inCart ? <><i className="fas fa-cart-shopping"></i> In Cart</> : <><i className="fas fa-cart-plus"></i> Book Room</>}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Rooms() {
  const { cartCount } = useCart();
  useEffect(() => { new WOW({ mobile: false, live: true }).init(); }, []);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle title="Rooms & Accommodation" breadcrumbs={[{ label: 'Rooms' }]} />

      <section className="rooms-page-section pt-80 pb-80">
        <div className="auto-container">
          {/* Rate Tiers Banner */}
          <div className="rate-tiers-banner wow fadeInUp">
            <h5>Manchester Villa Hotel — Rate Tiers</h5>
            <div className="tiers-row">
              {tiers.map((t, i) => (
                <div key={i} className="tier-pill" style={{ borderColor: t.color }}>
                  <span className="tier-flag">{t.flag}</span>
                  <div>
                    <strong style={{ color: t.color }}>{t.name}</strong>
                    <span>{t.price} / night</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {cartCount > 0 && (
            <div className="cart-notice mb-4">
              <i className="fas fa-cart-shopping"></i>
              <span>You have <strong>{cartCount}</strong> item{cartCount !== 1 ? 's' : ''} in your cart.</span>
              <Link to="/cart" className="cart-notice-link">View Cart &rarr;</Link>
            </div>
          )}

          <div className="sec-title text-center wow fadeInUp mt-4">
            <span className="sub-title">Our Accommodation</span>
            <h2>Choose Your Room</h2>
            <p className="text" style={{ maxWidth: 580, margin: '0 auto' }}>All rooms include free WiFi, 24-hour power, air-conditioning, flat-screen Smart TV, and en-suite bathroom. Rates are per night.</p>
          </div>
          <div className="row g-4 mt-2">
            {rooms.map((room, i) => (
              <div key={room.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${(i % 3) * 150}ms`}>
                <RoomCard room={room} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
